import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import {CustomBook} from '../../../components/Book/Book';
import { useNavigate, useSearchParams } from 'react-router-dom';
import FloatButton from '../../../components/FloatButton/FloatButton';
import { useUserStore } from '../../../store/useUser';
import HeaderPage from '../../../components/HeaderPage/HeaderPage';
import { main_color_50 } from '../../../styles/_variables';
import { StateBook } from '../../../models/books';
import useSearchParam from '../../../hooks/useQueryParams';
import Filter, { FilterItem } from '../../../components/Filter/CustomFilter';
import { getUserBookcase } from '../../../service/bookcase';

import styles from './ListBookcase.module.scss'
import { Spin } from 'antd';

import { getUserIdByPathname } from '../../../utils/user';
import { getUser } from '../../../service/user';
import useHeader from '../../../hooks/useHeader';

const ListUserBookcase: React.FC = () => {
  const navigate = useNavigate()
  const [searchState, setSearchState] = useSearchParam<string, StateBook | ''>('stateBook')
  
  const userId = getUserIdByPathname()

  const { data: user, isFetching: isFetchingUser } = useQuery(
    ['user'],
    () => getUser(userId),
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false },
  );

  const {data: bookcase, isFetching} = useQuery(
    ['user', userId, searchState],
    () => getUserBookcase(userId, searchState),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const onClickFloatButton = (e) => {
    navigate('/book');
  }

  useHeader({ header: user?.fullname, subheader: 'Estante' });

  return (
      <div className={styles.container}>
        <HeaderPage header="Estante" bageColor={main_color_50}/>
        <Filter>
          <FilterItem 
            onClick={e => setSearchState('')} 
            active={!searchState}>
              Todos
          </FilterItem>
          <FilterItem 
            onClick={e => setSearchState('read')} 
            active={searchState === 'read'}>
              Lidos
          </FilterItem>
          <FilterItem 
            onClick={e => setSearchState('abandoned')} 
            active={searchState === 'abandoned'}>
              Abandonados
          </FilterItem>
          <FilterItem 
            active={searchState === 'reading'}
            onClick={e => setSearchState('reading')}> 
              Lendo
          </FilterItem>
          <FilterItem 
            active={searchState === 'want'}
            onClick={e => setSearchState('want')}>
              Quero lê
          </FilterItem>
        </Filter> 
        <Spin spinning={isFetching}>
          <div className={styles.containerBooks}>
            {bookcase?.map(book => 
              <CustomBook
                bookId={book.bookId}
                key={book.bookId}
              />
            )}
          </div>
        </Spin>
        <FloatButton onClick={onClickFloatButton}/>
      </div>
  )
}

export default ListUserBookcase;